export enum MenuPointUrl {
	tests = '/tests',
}
